import styled, { css } from "styled-components";
import { Selector } from "../Selector/Selector.styled";

export const SubscribersSection = styled.div`
  background: #fafaff;
  padding: 32px 40px 40px;
`;

export const Description = styled.div`
  margin-bottom: 24px;

  > h3 {
    font-family: "Rubik", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #1e1f46;
    margin: 0;
    margin-bottom: 4px;
  }

  > p {
    font-family: "Rubik", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #667085;
  }

  a {
    font-family: "Rubik", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #667085;
    text-decoration: underline;
  }
`;

export const Container = styled.div`
  user-select: none;

  ${Selector}:last-child {
    margin-bottom: 0;
  }

  ${({ isDisabled }) =>
    isDisabled
      ? css`
          opacity: 0.3;
          cursor: not-allowed;
          pointer-events: none;
        `
      : css`
          opacity: 1;
          cursor: auto;
          pointer-events: auto;
        `}
`;
